// extracted by mini-css-extract-plugin
var _1 = "VerificationPageStyle-module__awaiting_verification___nbt7j";
var _2 = "VerificationPageStyle-module__awaiting_verification___nbt7j";
var _3 = "VerificationPageStyle-module__fully_verified___EGaFA";
var _4 = "VerificationPageStyle-module__fully_verified___EGaFA";
var _5 = "VerificationPageStyle-module__incomplete___fHR8y";
var _6 = "VerificationPageStyle-module__page-description___YvEs4";
var _7 = "VerificationPageStyle-module__page-description___YvEs4";
var _8 = "VerificationPageStyle-module__part_verified___fe2jL";
var _9 = "VerificationPageStyle-module__part_verified___fe2jL";
var _a = "VerificationPageStyle-module__rejected___K454d";
var _b = "VerificationPageStyle-module__section___x0HeO";
var _c = "VerificationPageStyle-module__section--identities___a15vm";
var _d = "VerificationPageStyle-module__section-header___jL6XZ";
var _e = "VerificationPageStyle-module__section-header___jL6XZ";
var _f = "VerificationPageStyle-module__section--identities___a15vm";
var _10 = "VerificationPageStyle-module__status___yZlC1";
var _11 = "VerificationPageStyle-module__status-container___Ta5_e";
var _12 = "VerificationPageStyle-module__status-info___ktiy3";
var _13 = "VerificationPageStyle-module__status-container___Ta5_e";
var _14 = "VerificationPageStyle-module__status-info___ktiy3";
var _15 = "VerificationPageStyle-module__unverified___X5n9S";
var _16 = "VerificationPageStyle-module__verification-content___e8l07";
var _17 = "VerificationPageStyle-module__verification-header___nTzFv";
var _18 = "VerificationPageStyle-module__verification-content___e8l07";
var _19 = "VerificationPageStyle-module__verification-header___nTzFv";
var _1a = "VerificationPageStyle-module__verified___NdkLq";
export { _1 as "awaitingVerification", _2 as "awaiting_verification", _3 as "fullyVerified", _4 as "fully_verified", _5 as "incomplete", _6 as "page-description", _7 as "pageDescription", _8 as "partVerified", _9 as "part_verified", _a as "rejected", _b as "section", _c as "section--identities", _d as "section-header", _e as "sectionHeader", _f as "sectionIdentities", _10 as "status", _11 as "status-container", _12 as "status-info", _13 as "statusContainer", _14 as "statusInfo", _15 as "unverified", _16 as "verification-content", _17 as "verification-header", _18 as "verificationContent", _19 as "verificationHeader", _1a as "verified" }
